/*
 * @Date: 2023-03-22 09:46:25
 * @LastEditors: guantingting
 * @LastEditTime: 2023-03-23 15:09:20
 */
export default [
  {
    path: '/rent/v2/newCarDetail',
    name: 'newCarDetail',
    component: () => import('@/pages/newCar/newCarDetail'),
    meta: { title: '车辆详情', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarHome',
    name: 'newCarHome',
    component: () => import('@/pages/newCar/newCarHome'),
    meta: { title: '新车选购', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarIndex',
    name: 'newCarIndex',
    component: () => import('@/pages/newCar/newCarIndex'),
    meta: { title: '新车选购', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarBrandDetail',
    name: 'newCarBrandDetail',
    component: () => import('@/pages/newCar/newCarBrandDetail'),
    meta: { title: '品牌详情', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarBrand',
    name: 'newCarBrand',
    component: () => import('@/pages/newCar/newCarBrand'),
    meta: { title: '品牌介绍', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarSearch',
    name: 'newCarSearch',
    component: () => import('@/pages/newCar/search'),
    meta: { title: '新车搜索', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarConfig',
    name: 'newCarConfig',
    component: () => import('@/pages/newCar/newCarConfig'),
    meta: { title: '车辆配置', requireAuth: true },
  },
  {
    path: '/rent/v2/newCarMyCollect',
    name: 'newCarMyCollect',
    component: () => import('@/pages/newCar/myCollect'),
    meta: { title: '我的收藏', requireAuth: true },
  }, 
]



// WEBPACK FOOTER //
// ./src/pages/newCar/car.js